import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import { useParams } from "react-router-dom";
import { api } from "../../utils/Api";
import toast from "react-hot-toast";

const initial_value = {
  selected_user: {},
  message: "",
  show_user_list: true,
};

let myModal = {};

export default function ServiceProviderListModal(props) {
  const [save_data, SetSaveData] = useState(initial_value);
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [id_value, SerIdValue] = useState(useParams());
  const [next_page, SetNextPage] = useState(false);
  const [user_data, SetUserData] = useState([]);
  const [timer, SetTimer] = useState(null);
  const [page_no, SetPageNo] = useState(1);
  const [text, setText] = useState("");
  const WAIT_INTERVAL = 700;

  useEffect(() => {
    console.log("ServiceProviderListModal On mount :", props);
    let myModal1 = document.getElementById("ServiceProviderListModal");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      //   SetCloseData({ action: "close" });
      SetSaveData(initial_value);
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.open) {
      console.log("ServiceProviderListModal On props.open :", props);
      //   SetCloseData({ action: "close" });
      myModal = new bootstrap.Modal(
        document.getElementById("ServiceProviderListModal"),
        {}
      );
      myModal.show();
      get_users(1);
    }
  }, [props.open]);

  async function request_user() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
      post: {
        user_id: save_data.selected_user.id,
        message: save_data.message,
      },
    };
    let response = await api("/outlet/add_service_provider", pass_data);
    console.log("add_service_provider response :", response);
    if (response.status_code == 200) {
      console.log("Message :", response.response.message);
      toast.error(response.response.message);
    }
    if (response.status_code == 201) {
      let item = close_data;
      item.action = "close";
      SetCloseData(item);
      myModal.hide();
    }
  }

  async function get_users(page_value: any, search_value = null) {
    let pass_data = {};
    if (search_value != null) {
      pass_data = {
        get: {
          brand: id_value.brand_id,
          outlet: id_value.outlet_id,
          page: page_value,
          search: search_value,
        },
      };
    } else {
      pass_data = {
        get: {
          brand: id_value.brand_id,
          outlet: id_value.outlet_id,
          page: page_value,
        },
      };
    }
    let response = await api(
      "/outlet/get_users_add_service_provider",
      pass_data
    );
    console.log("/outlet/get_users_add_service_provider response :", response);
    if (response.response.data) {
      SetUserData(response.response.data);
    }
    SetNextPage(response.response.next_page);
  }

  function onTextChanged(e: any) {
    clearTimeout(timer);
    const value = e.target.value;
    setText(value);
    if (value == "") {
      let page_no_value = 1;
      SetPageNo(page_no_value);
      get_users(page_no_value);
    } else {
      SetTimer(
        setTimeout(() => {
          get_users(1, value);
        }, WAIT_INTERVAL)
      );
    }
  }

  async function load_more(search_value = "") {
    let page_no_value = page_no + 1;
    let pass_data = {};

    SetPageNo(page_no_value);
    if (search_value != "") {
      pass_data = {
        get: {
          brand: id_value.brand_id,
          outlet: id_value.outlet_id,
          page: page_no_value,
          search: search_value,
        },
      };
    } else {
      pass_data = {
        get: {
          brand: id_value.brand_id,
          outlet: id_value.outlet_id,
          page: page_no_value,
        },
      };
    }
    let response = await api(
      "/outlet/get_users_add_service_provider",
      pass_data
    );
    console.log("Users get_users_add_service_provider response :", response);
    SetUserData((prevValue) => {
      response.response.data.map((item) => {
        prevValue.push(item);
      });
      return [...prevValue];
    });
    SetNextPage(response.response.next_page);
  }

  return (
    <div
      className="modal fade"
      id="ServiceProviderListModal"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            {save_data.show_user_list ? (
              <h5 className="  modal-title" id="ModalLabel">
                Service Provider List
              </h5>
            ) : (
              <>
                <div
                  className="cursor"
                  onClick={() => {
                    SetSaveData((oldValues) => ({
                      ...oldValues,
                      show_user_list: true,
                    }));
                  }}
                >
                  <img
                    src={require("../../assets/icon/svg/arrow-left.svg")}
                    className="px-2"
                  />
                </div>
                <h5 className="  modal-title" id="ModalLabel">
                  Request User
                </h5>
              </>
            )}

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>
          <div className="modal-body">
            {save_data.show_user_list ? (
              <div className="row">
                <div className="col-12">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search Editors"
                    defaultValue={text}
                    onChange={(e) => {
                      onTextChanged(e);
                    }}
                  />
                </div>

                <h6 className="mt-4">Available Users</h6>
                <div className="mt-3 users_scroll">
                  {user_data.map((item, sugIndex) => (
                    <div className="border-bottom p-2 py-3 mb-2" key={sugIndex}>
                      <div className="row align-items-center">
                        <div className="col-2 col-sm-1 col-md-1 p-md-0">
                          {item.dp_url != null ? (
                            <img
                              src={item.dp_url}
                              className="img-radius w-100"
                            />
                          ) : (
                            <img
                              src={require("../../assets/img/profile.png")}
                              className="img-radius w-100"
                            />
                          )}
                        </div>
                        <div className="col-7 col-md-8">
                          <p
                            className={
                              item.existing_user
                                ? "text-gray mb-0 fs-6 fw-bolder"
                                : "text-dark mb-0"
                            }
                          >
                            {item.name}
                          </p>
                          <small>@{item.user_name}</small>
                        </div>
                        <div className="col-3 p-0 text-end ">
                          {item.existing_user ? (
                            <small className="text-red mb-0 fs-7">
                              Already exists
                            </small>
                          ) : (
                            <span
                              className="btn btn-sm btn-light-outline"
                              onClick={() => {
                                // if (!item.existing_user) {
                                SetSaveData((oldValues) => ({
                                  ...oldValues,
                                  selected_user: item,
                                  show_user_list: false,
                                }));
                                // }
                                console.log("Select item:", item);
                              }}
                            >
                              Select
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}

                  {next_page ? (
                    <p
                      className="text-primary pt-3 cursor text-center"
                      onClick={() => {
                        load_more(text);
                      }}
                    >
                      Load More
                    </p>
                  ) : null}
                </div>
              </div>
            ) : (
              <div>
                <p className="px-2">
                  User Name : {save_data.selected_user.name}
                </p>
                <div className="mt-2">
                  <label className="form-label">Message</label>
                  <textarea
                    className="form-control"
                    onChange={(e) => {
                      SetSaveData((oldValues) => ({
                        ...oldValues,
                        message: e.target.value,
                      }));
                    }}
                  />
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer">
            {save_data.show_user_list ? (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  let item = close_data;
                  item.action = "close";
                  SetCloseData(item);
                  myModal.hide();
                }}
              >
                Cancel
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => {
                  console.log("request :", save_data);
                  request_user();
                }}
              >
                Request
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
